import { create } from "zustand";

interface PreviewUpdateState {
  lastPreviewUpdate: number;
  updatedComponents: Set<string>; // Track which components were updated
  notifyPreviewUpdate: (componentKey?: string) => void;
  clearUpdatedComponent: (componentKey: string) => void;
  hasComponentUpdate: (componentKey: string) => boolean;
}

export const usePreviewUpdateStore = create<PreviewUpdateState>((set, get) => ({
  lastPreviewUpdate: 0,
  updatedComponents: new Set(),

  notifyPreviewUpdate: (componentKey?: string) =>
    set((state) => {
      const newUpdatedComponents = new Set(state.updatedComponents);
      if (componentKey) {
        newUpdatedComponents.add(componentKey);
      }
      return {
        lastPreviewUpdate: Date.now(),
        updatedComponents: newUpdatedComponents,
      };
    }),

  clearUpdatedComponent: (componentKey: string) =>
    set((state) => {
      const newUpdatedComponents = new Set(state.updatedComponents);
      newUpdatedComponents.delete(componentKey);
      return {
        updatedComponents: newUpdatedComponents,
      };
    }),

  hasComponentUpdate: (componentKey: string) => {
    return get().updatedComponents.has(componentKey);
  },
}));
